import { ErrorString, InvalidOperationException } from "../../shared/index.js";
export const singleAsync = async (source, predicate) => {
    let hasValue = false;
    let singleValue = null;
    for (const value of source) {
        if (await predicate(value)) {
            if (hasValue === true) {
                throw new InvalidOperationException(ErrorString.MoreThanOneMatchingElement);
            }
            else {
                hasValue = true;
                singleValue = value;
            }
        }
    }
    if (hasValue === false) {
        throw new InvalidOperationException(ErrorString.NoMatch);
    }
    return singleValue;
};
